module.exports = __webpack_public_path__ + "img/zhijvyun1.f9c3e7e3.png";